
document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('.delivery-checker-block');
  blocks.forEach((block) => {
    const blockId = block.getAttribute('data-block-id');
    const dataEl = document.getElementById(`delivery-checker-${blockId}-data`);
    let popupImageUrl = null;
    let messages = {};

    if (dataEl) {
      try {
        const parsed = JSON.parse(dataEl.textContent || '{}');
        popupImageUrl = parsed.popupImage || null;
        messages = parsed.messages || {};
      } catch (e) {
        console.error('Delivery checker: failed to parse block data', e);
      }
    }

    const isUS = block.classList.contains('delivery-checker--us');

    const deliveryCheckFunc = (postcode) => {
      const extract = (postcode || '').replace(/\s/g, '');
      if (extract.length === 0) return 'invalid';
      if (extract.length > 7 || (isUS === true && extract.length != 5)) return 'invalid';

      let flag = '';
      const up = (postcode || '').toUpperCase();

      (window.postcodeArea1 || []).some((element) => {
        if (element && up.indexOf(element) === 0) {
          flag = 'first';
          return true;
        }
        return false;
      });

      if (!flag) {
        (window.postcodeArea2 || []).some((element) => {
          if (element && up.indexOf(element) === 0) {
            flag = 'second';
            return true;
          }
          return false;
        });
      }

      if (!flag) {
        (window.postcodeArea3 || []).some((element) => {
          if (element && up.indexOf(element) === 0) {
            flag = 'third';
            return true;
          }
          return false;
        });
      }

      if (flag) return flag;
      return 'not_found';
    };

    function ensureDeliveryPopup() {
      if (document.getElementById('delivery-popup')) return;
      const html = `
      <div id="delivery-popup" class="delivery-popup">
        <div id="delivery-popup-overlay" class="delivery-popup__overlay"></div>
        <div class="delivery-popup__panel">
          <button id="delivery-popup-close" class="delivery-popup__close" aria-label="Close">✕</button>
          <div id="delivery-popup-content" class="delivery-popup__content"></div>
          ${popupImageUrl ? `<div class=\"delivery-popup__media\"><img src=\"${popupImageUrl}\" class=\"delivery-popup__image\" alt=\"\"></div>` : ''}
        </div>
      </div>`;
      document.body.insertAdjacentHTML('beforeend', html);
      document.getElementById('delivery-popup-close')?.addEventListener('click', hideDeliveryPopup);
      document.getElementById('delivery-popup-overlay')?.addEventListener('click', hideDeliveryPopup);
    }

    function showDeliveryPopup(messageHtml) {
      ensureDeliveryPopup();
      const container = document.getElementById('delivery-popup');
      const content = document.getElementById('delivery-popup-content');
      if (content) content.innerHTML = messageHtml || '';
      if (container) container.classList.add('is-open');
    }

    function hideDeliveryPopup() {
      const container = document.getElementById('delivery-popup');
      if (container) container.classList.remove('is-open');
    }

    const postcodeInput = block.querySelector('[data-postcode-input]');
    const postcodeBtn = block.querySelector('[data-postcode-check-btn]');

    postcodeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const val = postcodeInput?.value || '';
      const res = deliveryCheckFunc(val);
      const messageHtml = messages[res] || messages.not_found || 'No delivery available';
      showDeliveryPopup(messageHtml);
    });
  });
});
